module.exports = __webpack_public_path__ + "img/50ne.b51d4890.svg";